// deps
import React, { memo, useCallback } from "react";

// internal-deps
import ElementObserver from "@swiggy-private/dls-react-mxn/dist/ElementObserver";
import {
    IColors,
    ITypography,
} from "@swiggy-private/dls-web-common/dist/components/types.internal";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import { Container } from "./styles";

export interface IContent {
    text: string | React.ReactNode;
    variant?: keyof ITypography;
    color?: keyof IColors;
}

export interface IFloatingWidgetProps {
    visible: boolean;
    leftContent: IContent;
    rightContent: IContent;
    handler: () => void;
    impressionAnalytics?: () => void;
    clickAnalytics?: () => void;
}

const FloatingWidget: React.FC<IFloatingWidgetProps> = ({
    visible,
    leftContent,
    rightContent,
    handler,
    impressionAnalytics,
    clickAnalytics,
}) => {
    const onContainerClick = useCallback(() => {
        clickAnalytics?.();
        handler();
    }, [handler, clickAnalytics]);

    if (!visible) return null;

    return (
        <ElementObserver onViewEnter={impressionAnalytics} senseOnce>
            <Container onClick={onContainerClick}>
                <Text
                    variant={leftContent.variant || "V2.body2.neutral.bold"}
                    color={leftContent.color || "background_Primary"}
                >
                    {leftContent.text}
                </Text>
                <Text
                    variant={rightContent.variant || "V2.body2.neutral.bold"}
                    color={rightContent.color || "background_Primary"}
                >
                    {rightContent.text}
                </Text>
            </Container>
        </ElementObserver>
    );
};

export default memo(FloatingWidget);
